import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { LoadXconfs } from '@core/infrastructure/state/core-commands.actions';

@Injectable()
export class CategoryPageResolver {
    private readonly store = inject(Store);

    public resolve(): void {
        const xConfProps = ['SHOW_LOCAL_STORE', 'SHOW_SPECIAL_MSPOT_FAMILIES', 'SEASONS_STOCK_QUERY_ALLOWED', 'PRODUCT_DIMESIONS', 'SHOW_PRODUCT_CATEGORY_SKU_NO_STOCK'];
        this.store.dispatch(LoadXconfs({ xConfs: xConfProps }));
    }
}
